import { useSelector } from '@xstate/react';

import Popover from 'components/Popover';
import { useGlobalMachinesContext, useUserContext } from 'contexts';
import type { VariantId } from 'models/product';
import { selectIsAuthenticatedUser } from 'state-machines/session';

import WatchableSignup from './WatchableSignup';

interface Props {
	isOpen: boolean;
	knownCustomerText: string;
	onClose: () => void;
	popoverHeading: string;
	productId: VariantId;
	submitButtonText: string;
	successText: string;
	unknownCustomerText: string;
}

export default function WatchableVariantPopover({
	isOpen,
	knownCustomerText,
	onClose,
	popoverHeading,
	productId,
	submitButtonText,
	successText,
	unknownCustomerText,
}: Props) {
	const { sessionService } = useGlobalMachinesContext();
	const isAuthenticatedUser = useSelector(
		sessionService,
		selectIsAuthenticatedUser,
	);
	const { email, voyadoContactId } = useUserContext();
	const shouldAskForEmail =
		!isAuthenticatedUser ||
		(isAuthenticatedUser && (!voyadoContactId || !email));
	return (
		<Popover
			id="watchable-signup-popover"
			isOpen={isOpen}
			title={popoverHeading}
			onClose={onClose}
		>
			<WatchableSignup
				knownCustomerText={knownCustomerText}
				onClose={onClose}
				unknownCustomerText={unknownCustomerText}
				shouldAskForEmail={shouldAskForEmail}
				submitButtonText={submitButtonText}
				successText={successText}
				userEmail={email}
				variantId={productId}
			/>
		</Popover>
	);
}

WatchableVariantPopover.displayName =
	'ProductDetails_StockInformation_WatchableVariantPopover';
